import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import { Form, Formik } from "formik";
import api from "../../../API";
import { useSelector } from "react-redux";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import NKIWorkerListPage from "./NKIWorkerListPage";

interface IFileTypes {
  id: number;
  object: File;
}

interface UploadResult {
  fileName: string;
  state: string;
}


// const SampleRejectRsnDialog = () => {
const NKIUploadDialog = (props: any) => {

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const speaker1 = props.speaker1;
  // const speaker2 = props.speaker2;
  const [speaker2, setSpeaker2] = useState('');

  // console.log('스피커 ??? ' , speaker1 , speaker2)

  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [files, setFiles] = useState<IFileTypes[]>([]);
  const [uploadResult , setUploadResult] = useState<UploadResult[]>([]);

  const dragRef = useRef<HTMLLabelElement | null>(null);
  const fileId = useRef<number>(0);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  // const email = 'parkji7980@naver.com'

  const fileUpload = async () => {

    if(speaker2 == ''){
      alert("현재 연결 화자가 없습니다. 화자를 연결해주세요.");
      return;
    }

    if (files.length === 0) {
      alert("업로드할 파일을 선택해주세요.");
      return;
    }
    const formData = new FormData();
    // 선택한 파일들을 formData에 추가
    // const file_data:any = {};

    formData.append("email", email);

    let audio_cnt = 0;
    let srt_cnt = 0;

    let audio_list = Array<any>([])
    let srt_list = Array<any>([])

    


    files.forEach((file:any) => {
      console.log('업로드할 파일' , file.object)
      const filename_split = file.object.name.split(".")
      const extension = filename_split.pop();
      const file_name = filename_split.join(".");
      console.log('file_name', file_name)
      console.log('extension', extension)

      
      
      if(extension && ["mp3","mp4","wav","ogg","m4a","aac"].includes(extension.toLowerCase())){
        formData.append("audio", file.object.name);
        audio_list.push(file_name)
        audio_cnt +=1;
      }
      else if(extension && ["srt"].includes(extension.toLowerCase())){
        formData.append("srt", file.object.name);
        srt_list.push(file_name)
        srt_cnt +=1;
      }
      else{
        alert(file.object.name + ' 확장자('+extension+')를 확인하여주세요.')
        return;
      }
      formData.append("files", file.object);


      console.log('file.object.lastModifiedDate',file.object.lastModifiedDate)
      const fileInfo = {
        fileName: file.object.name,
        lastModifiedDate: file.object.lastModifiedDate,
      };
      formData.append("files_lastmodified", JSON.stringify(fileInfo));

      // formData.append("files_lastmodified", {
      //   fileName : file.object.name,
      //   lastModifiedDate : file.object.lastModifiedDate.toISOString(),
      // });

    });

    if(audio_cnt != srt_cnt){
      alert('음성파일과 자막(SRT)파일의 개수가 다릅니다. 쌍을 확인해주세요.')
      return;
    }

    console.log('audio_list',audio_list)
    console.log('srt_list',srt_list)

    if(JSON.stringify(audio_list) !== JSON.stringify(srt_list)){
      // console.log('오디오 SRT 일치합니다!!!!!')
      const audio_filter = audio_list.filter(item => !srt_list.includes(item));
      const srt_filter = srt_list.filter(item => !audio_list.includes(item));
      alert('녹음파일의 파일명과 자막(SRT)파일의 명칭이 다른것이 있습니다.\n다시 확인바랍니다.\n녹음파일 목록 :\n' + audio_filter + '\n자막파일 목록 :\n' + srt_filter)
      return ;
    }

    // return ;

    formData.append("speaker1", speaker1);
    formData.append("speaker2", speaker2);

    // return;

    setBackdrop(true)
    // nvSttSrtOnlyUpload
    // dialogOrgUpload
    const result = await api.post("/dialogOrgUpload", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
        // "Content-Type": "application/json"
      }
    })
    .then((res:any) => {
      setBackdrop(false); 
      console.log("file upload ", res); 
      setUploadResult(res.data.datas); 
      // setFiles([]);
      alert('업로드 처리가 끝났습니다. 결과를 꼭 확인하여 주세요.')
      // props.myScriptList();
      // props.setUploadDialogOpen(false);
    })
    // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {
      setBackdrop(false); 
      var res = JSON.parse(error.response.data);
      console.error('에러',res); 
      alert('파일 업로드에 실패하였습니다.\n'+ res['fileName'] + '\n'+ res['state'])
      // alert(res['fileName'] + ' 파일은 이미 업로드 되어있습니다. [상태 : ' + res['state'] + ']')
    })
    // alert("파일 업로드 실패. " + error.response.data.error);
      
  };

  const onChangeFiles = useCallback(
    (e: ChangeEvent<HTMLInputElement> | any): void => {
      let selectFiles: File[] = [];
      let tempFiles: IFileTypes[] = files;
  
      if (e.type === "drop") {
        selectFiles = e.dataTransfer.files;
      } else {
        selectFiles = e.target.files;
      }
  
      for (const file of selectFiles) {
        const extension = file.name.split(".").pop();
  
        // 파일업로드 확장자 통과목록

        // if (extension === "mp3" || extension === "wav" || extension === "ogg" || extension === "m4a" || extension === "M4A") {

        const isDuplicate = tempFiles.some(
          (tempFile) =>
            tempFile.object.name === file.name
        );
        if (isDuplicate) {
          alert(`${file.name} 파일은 이미 추가되었습니다.`);
        } else if (
          extension &&
          ["mp3","mp4","wav","ogg","m4a","aac","srt"].includes(extension.toLowerCase())
        ) {
        tempFiles = [
          ...tempFiles,
          {
            id: fileId.current++,
            object: file,
          },
        ];
        } else {
          // alert("오디오 파일만 업로드 가능합니다.");
          alert("업로드가 불가한 파일 확장자를 포함합니다. 다시확인하여 주세요.");
        }
      }
      setFiles(tempFiles);
    },
    [files]
  );
  
  const handleFilterFile = useCallback(
    (id: number): void => {
      setFiles(files.filter((file: IFileTypes) => file.id !== id));
    },
    [files]
  );

  const handleDragIn = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragOut = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer!.files && e.dataTransfer!.files.length > 0) {
      const extension = e.dataTransfer!.files[0].name.split(".").pop();
      if (extension && ["mp3","wav","ogg","m4a","srt","txt","png","jpg","jpeg"].includes(extension.toLowerCase())
      ) {
        setIsDragging(true);
      } else {
        setIsDragging(false);
      }
    }
  }, []);

  const handleDrop = useCallback(
    (e: DragEvent): void => {
      e.preventDefault();
      e.stopPropagation();

      onChangeFiles(e);
      setIsDragging(false);
    },
    [onChangeFiles]
  );

  const initDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.addEventListener("dragenter", handleDragIn);
      dragRef.current.addEventListener("dragleave", handleDragOut);
      dragRef.current.addEventListener("dragover", handleDragOver);
      dragRef.current.addEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  const resetDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.removeEventListener("dragenter", handleDragIn);
      dragRef.current.removeEventListener("dragleave", handleDragOut);
      dragRef.current.removeEventListener("dragover", handleDragOver);
      dragRef.current.removeEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  

  useEffect(() => {
    initDragEvents();

    return () => resetDragEvents();
  }, [initDragEvents, resetDragEvents]);


  return (
    <Box >
    <Dialog maxWidth="md" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>본작업 수집데이터 파일업로드</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdrop} >
            <CircularProgress color="inherit" /> 업로드 중...
          </Backdrop>
          <Box sx={{width:"100%"}}>
            <Box>
              <NKIWorkerListPage setSpeaker2={setSpeaker2}/>
              <Paper sx={{width: "770px", padding: "38px", borderTop: "4px solid #3e36a5"}}>
                <Box sx={{padding:"20px 8px 8px 8px"}}>
                  <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "32px", letterSpacing:"-2px"}}>대화 수집 파일 제출</Box>
                  <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
                  <div className="DragDrop">
                  <input
                    type="file"
                    id="fileUpload"
                    style={{ display: "none" }}
                    multiple={true}
                    onChange={onChangeFiles}
                  />

                  <label
                    className={isDragging ? "DragDrop-File-Dragging" : "DragDrop-File"}
                    htmlFor="fileUpload"
                    ref={dragRef}
                    style={{width: "100%" , backgroundColor:"#71a7e5"}}
                  >
                    <Box sx={{fontWeight:700, fontSize:"32px", color:"#fff"}}>파일 첨부</Box>
                  </label>
                  
                  <div className="DragDrop-Files">
                    {files.length > 0 ?
                      files.map((file: IFileTypes) => {
                        const {
                          id,
                          object: { name },
                        } = file;

                        return (
                          <Box key={id} sx={{width:(uploadResult.length > 0 ? "100% !important":"300px") ,display:"flex",justifyContent: "flex-start !important"}}>
                            <Box sx={{display:"flex", alignItems: "center"}}>
                              <Box sx={{width:"180px",marginRight:"40px"}}>{name}</Box>
                              <Box
                                className="DragDrop-Files-Filter"
                                onClick={() => handleFilterFile(id)}
                              >
                                <CancelIcon fontSize="small" />
                              </Box>
                            </Box>
                            <Box>
                              {uploadResult.length > 0 ? 
                                uploadResult.filter((value:any) => value.fileName === name).map((result:any) =>
                                  <Box sx={{padding:2}} key={result.fileName}>
                                    {/* <Box sx={{fontWeight:600}}>{result.fileName}</Box> */}
                                    {result.state == "성공" ? 
                                      <Box sx={{marginLeft:"8px", fontWeight:600, color:"#27c527", display:"flex"}}><ExpandCircleDownIcon sx={{marginRight:1, color:"#27c527"}} />{result.state}</Box>
                                      : 
                                      <Box sx={{marginLeft:"8px", fontWeight:600, color:"red", display:"flex"}}><CancelIcon sx={{marginRight:1}} />{result.state}</Box>}
                                  </Box>
                                )
                              :""}
                            </Box>
                          </Box>
                        );
                      }) : ""}
                  </div>
                    {/* {(uploadResult.length > 0) ? 
                      (<Box sx={{border :"2px solid red", fontSize:"12px", padding:"8px"}}>
                        <Box sx={{fontSize:"16px", fontWeight:600}}>파일 업로드 결과</Box>
                        {uploadResult.map((result:UploadResult) => 
                          <Box sx={{padding:2}} key={result.fileName}>
                            <Box sx={{fontWeight:600}}>{result.fileName}</Box>
                            {result.state == "성공" ? 
                              <Box sx={{marginLeft:"8px", fontWeight:600, color:"#27c527", display:"flex"}}><ExpandCircleDownIcon sx={{marginRight:1, color:"#27c527"}} />{result.state}</Box>
                              : 
                              <Box sx={{marginLeft:"8px", fontWeight:600, color:"red", display:"flex"}}><CancelIcon sx={{marginRight:1}} />{result.state}</Box>}
                          </Box>
                        )}
                      </Box>)
                    : ""} */}
                  <Box sx={{display:"flex" , justifyContent: "end"}}>
                    <Button sx={{width: "230px", fontWeight: 500, backgroundColor: "#3bbd30", color: "#fff"}} variant="contained" onClick={fileUpload}>파일 업로드</Button>
                  </Box>
                </div>
                </Box>
                <Box sx={{fontWeight:500, marginLeft:2, fontSize:"14px"}}>
                  <Box color="blue" sx={{marginBottom:"4px"}}>수집파일을 첨부해주세요! {<b style={{color:"red"}}>(녹음파일 1개 + 자막파일 1개 = 1건)</b>}</Box>
                  <Box color="black" sx={{marginBottom:"4px"}}>1. 녹음한 {<b style={{color:"red"}}>음성파일</b>} , 자막정보 및 대화 {<b style={{color:"red"}}>SRT파일</b>} 은 사용한 {<b style={{color:"green"}}>스크립트 파일명</b>}과 같아야합니다.</Box>
                  <Box color="black" sx={{marginBottom:"4px"}}>2. 업로드 대상 파일들의 {<b style={{color:"red"}}>참석자 2</b>} 정보는 <b style={{color:"green"}}>연결화자</b>의 정보로 제출됩니다.</Box>
                  <Box color="black" sx={{marginBottom:"8px"}}>클로바노트를 사용하여 녹음한 음성파일로 SRT 자막 생성을 진행해주세요.<b style={{marginBottom:"8px"}}>(<a href="https://clovanote.naver.com/home" target="_blank" rel="noopener noreferrer">클로바노트 사이트 이동</a>)</b></Box>
                  {/* <Box><b style={{marginBottom:"8px"}}>(<a href="https://clovanote.naver.com/home" target="_blank" rel="noopener noreferrer">클로바노트 사이트 이동</a>)</b></Box> */}
                  <Box color="blue">업로드 방법 예시</Box>
                  <Box sx={{fontSize:"12px",marginLeft:"8px",marginBottom:"8px"}}>
                    <Box color="black">총 100건의 업로드 대상 파일 중 [참석자 2]를 담당한 사람이 총 2명('김XX', '이XX')으로 50건씩 한 경우</Box>
                    <Box color="black">50건의 파일을 업로드 대상으로 등록하고 연결화자 기능으로 '김XX' 연결 후 업로드</Box>
                    <Box color="black">나머지 50건 다시 업로드 파일 등록 후 연결화자 기능으로 '이XX' 연결 후 업로드</Box>
                    <Box color="black" >[참석자 2] 를 담당한 사람당 연결화자를 설정하여 업로드가 진행되어야합니다.(발화자 2명 = 2회)</Box>
                  </Box>
                  <Box color="blue">업로드 파일명 예시</Box>
                  <Box sx={{fontSize:"12px",marginLeft:"8px"}}>
                    <Box color="black">스크립트 파일 - {<b style={{color:"green"}}>03_1002000.txt</b>} </Box>
                    <Box color="black">녹음한 음성파일 - {<b style={{color:"red"}}>03_1002000.m4a</b>}  , 자막파일 - {<b style={{color:"red"}}>03_1002000.srt</b>}</Box>
                  </Box>
                  
                  {/* <Box color="black">예시 - {<b style={{color:"black"}}>A0001_101.txt</b>} 스크립트 사용 작업 파일</Box> */}
                  {/* <Box color="blue">첨부한 샘플파일은 관리자 검토 후 적합여부를 통지 합니다.(처리기간 4일 이내)</Box> */}
                </Box>
              </Paper>
              
            </Box>
          </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.setUploadDialogOpen(false);
            props.myScriptList();
          }}
        >
          취소
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default NKIUploadDialog;
